export default "__VITE_ASSET__Ch3mjw60__"